import * as z from 'zod';

export const ChangeRoleRequest = z.object({
  accountId: z
    .string()
    .describe("Contributor's account ID.")
    .regex(
      /^[0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}$/,
      'Must be a valid GUID'
    ),
  options: z
    .object({
      newRoles: z.array(
        z.object({
          roleId: z
            .string()
            .describe(
              'Role ID. Sometimes referred to as policy ID. See [Roles and Permissions](https://support.wix.com/en/article/roles-permissions-overview) for a list of available roles.'
            )
            .optional(),
          assignmentId: z
            .string()
            .describe(
              'Assignment ID mapping the role to the contributor on the site.'
            )
            .optional(),
        })
      ),
    })
    .describe('Filter options. The `newRoles` field **must** be passed.'),
});
export const ChangeRoleResponse = z.object({
  newAssignedRoles: z
    .array(
      z.object({
        roleId: z
          .string()
          .describe(
            'Role ID. Sometimes referred to as policy ID. See [Roles and Permissions](https://support.wix.com/en/article/roles-permissions-overview) for a list of available roles.'
          )
          .optional(),
        assignmentId: z
          .string()
          .describe(
            'Assignment ID mapping the role to the contributor on the site.'
          )
          .optional(),
      })
    )
    .optional(),
});
export const ChangeContributorLocationRequest = z.object({
  accountId: z
    .string()
    .describe("Contributor's account ID.")
    .regex(
      /^[0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}$/,
      'Must be a valid GUID'
    ),
  options: z.object({ newLocations: z.array(z.string()).max(20) }),
});
export const ChangeContributorLocationResponse = z.object({
  newAssignedLocations: z
    .array(
      z.object({
        locationIds: z.array(z.string()).max(100).optional(),
        assignmentIds: z.array(z.string()).max(999).optional(),
      })
    )
    .max(20)
    .optional(),
});
export const QuerySiteContributorsRequest = z.object({
  options: z
    .object({
      filter: z
        .object({
          policyIds: z.array(z.string()).max(20).optional(),
          locationIds: z.array(z.string()).max(20).optional(),
        })
        .describe('Filter object for narrowing search results.')
        .optional(),
    })
    .describe('Filter options.')
    .optional(),
});
export const QuerySiteContributorsResponse = z.object({
  contributors: z
    .array(
      z.object({
        accountId: z
          .string()
          .describe("Contributor's account ID.")
          .optional()
          .nullable(),
        accountOwnerId: z
          .string()
          .describe(
            'User ID of the owner of the account that the contributor belongs to.'
          )
          .optional()
          .nullable(),
      })
    )
    .optional(),
});
export const RemoveContributorRequest = z.object({
  accountId: z
    .string()
    .describe("Contributor's account ID to remove from the site.")
    .regex(
      /^[0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}$/,
      'Must be a valid GUID'
    ),
});
export const RemoveContributorResponse = z.object({});
